import chroma from 'chroma-js';

export const scale = (count, padding = 0.2) => {
  return chroma
    .scale('Blues') // (['#016ECC', '#6EC1E4'])
    .correctLightness()
    .mode('lrgb')
    .padding([padding, 0])
    .colors(count);
};

export const alpha = (colors, val) =>
  colors.map(color => chroma(color).alpha(val || 1));
